import React from 'react';
import InputField from '../../../components/input/input';
import SwitchSection from './SwitchSection';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';

interface OwnerSectionProps {
  owner: {
    value: 'yes' | 'no' | null;
    set: (value: 'yes' | 'no') => void;
    name: string;
    setName: (name: string) => void;
  };
}

const OwnerSection: React.FC<OwnerSectionProps> = ({ owner }) => {
  const currentUser = useSelector((state: RootState) => state.users.currentUser);
  const defaultOwnerName = `${currentUser?.firstName} ${currentUser?.lastName}` || '';

  const handleOwnerStatusChange = (value: 'yes' | 'no') => {
    owner.set(value);

    if (value === 'yes') {
      // When "Yes" is selected, set the current user's name as the owner
      owner.setName(defaultOwnerName);
    } else {
      // When "No" is selected, keep the existing entered name
      if (!owner.name || owner.name === defaultOwnerName) {
        owner.setName(''); // Clear name field if it's default
      }
    }
  };

  return (
    <SwitchSection<'yes' | 'no'>
      label="Are you the owner of the company?"
      parentTestID={'insurance-policy-final'}
      value={owner.value}
      onChange={handleOwnerStatusChange}
      buttons={[
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ]}
      childrenRenderCondition={(selectedValue) => selectedValue === 'no'}>
      <InputField
        testID={'insurance-policy-final-owner-name'}
        variant="caption"
        label="Owner's name"
        placeholder="Please insert the name of the owner"
        value={owner.name}
        onChange={(text) => owner.setName(text)}
      />
    </SwitchSection>
  );
};

export default OwnerSection;
